import { createActionGroup, props } from '@ngrx/store';
import { SetProductBookingParkingReservation } from '@products/models/booking.model';

export const ParkingBookingReservationActions = createActionGroup({
  source: 'Parking Booking Reservation',
  events: {
    'Set parking reservation in booking': props<SetProductBookingParkingReservation>()
  }
});
